import { createSelector } from 'reselect';
import { basicSelector, basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
import { getSectionById, getSelectedSection
// @ts-expect-error no declarations found for module
} from 'EmailEditorUI/redux/selectors/sectionSelectors';
import { getIsCustomEmail } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
import { getScrollContainer } from 'LayoutBuilderUI/utils/scrollPositionUtils';
const getUserInterface = basicSelector(state => state.userInterface);
export const getMouseOverSectionId = createSelector([getUserInterface], userInterface => userInterface.mouseOverSectionId);
export const getMouseOverElementId = createSelector([getUserInterface], userInterface => userInterface.mouseOverElementId);
export const getMouseOverCommentableAreaId = createSelector([getUserInterface], userInterface => userInterface.mouseOverCommentableAreaId);
export const getIsMouseOverChildElement = basicSelectorWithStats((state, sectionId) => {
  const mouseOverElementId = getMouseOverElementId(state) || getMouseOverCommentableAreaId(state) || '';
  const section = getSectionById(state, sectionId);
  if (!section) {
    return false;
  }
  const columns = section.get('columns');
  if (!columns) {
    return false;
  }
  return Boolean(columns.find(column => column.get('widgets').includes(mouseOverElementId)));
});
export const getIsFileManagerOpen = createSelector([getUserInterface], userInterface => userInterface.isFileManagerOpen);
export const getIsDraggingWithinApp = createSelector([getUserInterface], userInterface => userInterface.isDraggingWithinApp);
export const getDraggedItemType = createSelector([getUserInterface], userInterface => userInterface.draggedItemType);
const getDataThatUpdatesScrollContainerSize = state => {
  const userInterface = getUserInterface(state);
  if (getIsCustomEmail(state)) {
    return {
      scrollContainerBoundaries: userInterface.scrollContainerBoundaries
    };
  }
  return {
    scrollContainerBoundaries: userInterface.scrollContainerBoundaries,
    selectedSection: getSelectedSection(state)
  };
};

// this selector doesn't use the values passed in but we want to update the cached value based on them updating
export const getScrollContainerBoundaries = createSelector([getDataThatUpdatesScrollContainerSize], data => {
  const actualScrollContainer = getScrollContainer();
  if (actualScrollContainer) {
    const actualBoundaries = {
      top: 0,
      bottom: actualScrollContainer.offsetHeight,
      scrollTop: actualScrollContainer.scrollTop,
      scrollHeight: actualScrollContainer.scrollHeight,
      clientHeight: actualScrollContainer.clientHeight
    };
    return actualBoundaries;
  }
  return data.scrollContainerBoundaries;
});